__turbopack_context__.v({
  "airing_now": "Z8FUpW_airing_now",
  "is_past": "Z8FUpW_is_past",
  "listing": "Z8FUpW_listing",
  "listing__details": "Z8FUpW_listing__details",
  "listing__details__button": "Z8FUpW_listing__details__button",
  "listing__duration": "Z8FUpW_listing__duration",
  "listing__livestream_bug": "Z8FUpW_listing__livestream_bug",
  "listing__modal_trigger": "Z8FUpW_listing__modal_trigger",
  "listing__progress_bar": "Z8FUpW_listing__progress_bar",
  "listing__show_title": "Z8FUpW_listing__show_title",
  "listing__watch_btn__play_icon": "Z8FUpW_listing__watch_btn__play_icon",
  "listing__watch_now": "Z8FUpW_listing__watch_now",
  "selected_channel": "Z8FUpW_selected_channel",
});
